import styled from 'styled-components'
import { grid } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'pointerCursor'].includes(String(prop))
}

export const Container = styled(Flex).attrs({
  pb: [80, 80, 64, 64, 32],
  pt: [80, 80, 100, 100, 120],
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.primary')};
  position: relative;
`

export const Content = styled.div`
  width: 100%;
`

export const DotsWrapper = styled(Flex)
  .attrs({
    display: ['none', 'none', 'none', 'none', 'none', 'none', 'flex'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-40%);
  z-index: 0;
`

export const CropContainer = styled(Flex)
  .attrs({
    top: [0, 0, -72, -72, -72, -72, -120],
    width: [0, 0, 100, 100, 100, 100, 180],
    height: [0, 0, 200, 200, 200, 200, 300],
  })
  .withConfig({
    shouldForwardProp,
  })`
  right: 0;
  overflow: hidden;
  position: absolute;
`

export const CardsHolder = styled.div
  .attrs({
    gridTemplateColumns: ['1fr', '1fr', '1fr', 'repeat(4, 1fr)'],
    gridColumnGap: [0, 0, 0, 30, 40],
    gridRowGap: [30, 30, 40, 0],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;

  ${grid}
`

export const Card = styled(Flex)
  .attrs({
    flexDirection: ['row', 'row', 'row', 'column'],
  })
  .withConfig({
    shouldForwardProp,
  })``

export const IconHolder = styled(Flex)
  .attrs({
    width: [50, 50, 80, 100],
    height: [50, 50, 80, 100],
  })
  .withConfig({
    shouldForwardProp,
  })`
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  border-radius: 50px;
  background-color: ${themeGet('colors.white')};
`

export const TextContainer = styled(Flex).attrs({})`
  flex-direction: column;
`
